import React from 'react';
import { withTranslation } from 'react-i18next';
import PollDuperbrowseLink from './PollDuperbrowseLink';
class PollOverlay extends React.Component {
    render() {
        const { className, deviation, isOwner, t } = this.props;
        let label = 'poll.thumb.overlay.vote';
        if (isOwner || deviation.poll && deviation.poll.hasVoted) {
            label = 'poll.thumb.overlay.viewResults';
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: className
        }, /*#__PURE__*/ React.createElement(PollDuperbrowseLink, {
            deviation: deviation
        }, t(label)));
    }
}
export default withTranslation()(PollOverlay);
